import React, { useContext, useEffect, useState, useRef } from "react";
import "../../css_files/Admin/Users.css";
import axios from "axios";
import Register from "../Signin/Register";
import { triggerscroll } from "../Homepage/Homepage";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api";
import Pagination from "../Homepage/Pagination";

function Users() {
  const [usersdata, setusersdata] = useState([]);
  const [Search, setSearch] = useState("");
  const [showcreateuser, setshowcreateuser] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const { triggerscrollupwords } = useContext(triggerscroll);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [fetchuserdata, setfetcheduserdata] = useState(null);
  const [loading, setloading] = useState(false);
  const [pages, setpages] = useState(0);
  const [page, setpage] = useState(1);
  const [total, setTotal] = useState(0);
  const nav = useNavigate();

  const [passwordshow, setpasswordshow] = useState([]);

  useEffect(() => {
    setloading(true);
    setusersdata([]);
    const url = `${process.env.REACT_APP_API_URL}/api/User/GetAllUsers/${page}`;
    axiosInstance
      .post(url, {
        Search,
      })
      .then((res) => {
        setusersdata(res?.data?.data);
        setTotal(res?.data?.count);
        setpages(res?.data?.pages);
        setpasswordshow(
          Array.from({ length: res?.data?.data?.length }, () => false)
        );
        setloading(false);
      })
      .catch((err) => {
        if (err.status === 403) nav("/dashboard");
        setloading(false);
      });
  }, [refresh, page]);

  function fetchSingleUserData(userid) {
    setfetcheduserdata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/User/GetUserbyUserId?userId=${userid}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setfetcheduserdata(res.data);
      })
      .catch(console.log);
  }

  return (
    <section className="users-management-admin">
      <h1>Users Management</h1>
      {showcreateuser ? (
        <Register
          setshowcreateuser={setshowcreateuser}
          refresh={refresh}
          setrefresh={setrefresh}
          fetchuserdata={fetchuserdata}
          triggerupdate={triggerupdate}
          key={fetchuserdata?.userID}
        />
      ) : (
        <blockquote className="table-reset">
          <button
            onClick={() => {
              setshowcreateuser(true);
              triggerscrollupwords();
              settriggerupdate(false);
            }}
            style={{ padding: "0.7rem" }}
          >
            Create User{" "}
          </button>
          <input
            type="search"
            placeholder="Enter Search Keyword"
            id="searchUserinManageUsers"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setSearch(e.target.value?.trim());
                setrefresh(!refresh);
              }
            }}
            onInput={(e) => {
              if (e.target.value === "") {
                setSearch("");
                setrefresh(!refresh);
                setpage(1);
              }
            }}
          />
        </blockquote>
      )}
      <center>
        <p>{total} records</p>
      </center>
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
              <blockquote style={{ minWidth: "5rem" }}>Sr. No.</blockquote>
              <blockquote style={{ minWidth: "15rem" }}>Username</blockquote>
              <blockquote style={{ minWidth: "15rem" }}>Password</blockquote>
              <blockquote style={{ minWidth: "15rem" }}>Email</blockquote>
              <blockquote style={{ minWidth: "10rem" }}>
                Mobile Number
              </blockquote>
              <blockquote style={{ minWidth: "15rem" }}>Role</blockquote>
              <blockquote style={{ minWidth: "10rem" }}>
                Failed Login Attempts
              </blockquote>
              <blockquote style={{ minWidth: "10rem" }}>Status</blockquote>
              <blockquote style={{ minWidth: "10rem" }}>Lockout End</blockquote>
              <blockquote style={{ width: "10rem", gridColumn: "span 2" }}>
                Actions
              </blockquote>
            </aside>
          </div>
          <div>
            {loading ? (
              <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 11" }}>
                  <center>
                    <i
                      className="fa-solid fa-rotate-right fa-spin"
                      style={{ fontSize: "2.5rem" }}
                    ></i>
                  </center>
                </blockquote>
              </aside>
            ) : usersdata.length > 0 ?
              usersdata.map((user, index) => (
                <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
                  <blockquote style={{ minWidth: "5rem" }}>
                    {index + 1}
                  </blockquote>
                  <blockquote style={{ minWidth: "15rem" }}>
                    {user.userID}
                  </blockquote>
                  <blockquote
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "1rem",
                      minWidth: "15rem",
                    }}
                  >
                    <p hidden={passwordshow[index] === false}>
                      {user.hashPassword}
                    </p>
                    <p hidden={passwordshow[index]}>.........</p>
                    <i
                      className={`fa-solid ${
                        passwordshow[index] ? "fa-eye" : "fa-eye-slash"
                      }`}
                      onClick={() => {
                        setpasswordshow((prev) =>
                          prev.map((val, i) => (i === index ? !val : val))
                        );
                      }}
                    ></i>
                  </blockquote>
                  <blockquote style={{ minWidth: "15rem" }}>
                    {user.email}
                  </blockquote>
                  <blockquote style={{ minWidth: "10rem" }}>
                    {user.mobileNumber}
                  </blockquote>
                  <blockquote style={{ minWidth: "15rem" }}>
                    {user.role}
                  </blockquote>
                  <blockquote style={{ minWidth: "10rem" }}>
                    {user.failedLoginAttempts}
                  </blockquote>
                  <blockquote style={{ minWidth: "10rem" }}>
                    {user.isLocked ? "Inactive" : "Active"}
                  </blockquote>
                  <blockquote style={{ minWidth: "10rem" }}>
                    {user.lockoutEnd}
                  </blockquote>
                  <blockquote style={{ width: "5rem" }}>
                    <i
                      className="fa-solid fa-pen-to-square"
                      title="Edit"
                      onClick={() => {
                        setshowcreateuser(true);
                        triggerscrollupwords();
                        fetchSingleUserData(user.userID);
                        settriggerupdate(true);
                      }}
                    ></i>
                  </blockquote>
                  <blockquote style={{ width: "5rem" }}>
                    {passwordshow[index] ? (
                      <i className="fa-solid fa-spinner fa-spin"></i>
                    ) : (
                      <i
                        className={`fa-solid ${
                          user.isLocked ? "fa-square-xmark" : "fa-square-check"
                        }`}
                        style={{ color: user.isLocked ? "red" : "green" }}
                        title={user.isLocked ? "Inactive" : "Active"}
                        onClick={() => {
                          Swal.fire({
                            title: "Are you sure?",
                            text: `Do you want to change user status to ${
                              user.isLocked ? "Active" : "Inactive"
                            }`,
                            icon: "warning",
                            showCancelButton: true,
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setpasswordshow((prev) =>
                                prev.map((_, i) => i === index)
                              );
                              const url = `${process.env.REACT_APP_API_URL}/api/User`;
                              axiosInstance
                                .put(url, {
                                  UserID: user.userID,
                                  isLocked: !user.isLocked,
                                })
                                .then((res) => {
                                  setrefresh(!refresh);
                                })
                                .catch(console.log)
                                .finally(() => {
                                  setpasswordshow((prev) =>
                                    prev.map((_) => false)
                                  );
                                });
                            }
                          });
                        }}
                      ></i>
                    )}
                  </blockquote>
                </aside>
              )
            ): <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 11" }}>
                  No Records Found
                </blockquote>
              </aside>}
          </div>
        </section>
      </section>
      <Pagination count={pages} pagenumber={page} setpagenumber={setpage} />
    </section>
  );
}

export default Users;
